import { useQuery } from "@tanstack/react-query";
import { IApiPagination } from "../../../interfaces/IPagination";
import productPriceHistoryApi from "../services/productPriceHistory.api";
import { ProductPriceHistoryFilterType } from "..";

export type UseProductPriceHistoryQueryParams = {
  filter: ProductPriceHistoryFilterType;
  pagination: IApiPagination;
};

export const useProductPriceHistoryQuery = (
  params: UseProductPriceHistoryQueryParams,
) => {
  return useQuery({
    queryKey: ["product-price-histories", params],
    queryFn: async () => {
      const res = await productPriceHistoryApi.getProductPriceHistories(
        params.filter,
        params.pagination,
      );
      return res.data;
    },
    staleTime: 1000 * 60, // 1 minute
  });
};

export const useProductPriceHistoryByIdQuery = (id: string) => {
  return useQuery({
    queryKey: ["product-price-history", id],
    queryFn: () => productPriceHistoryApi.getProductPriceHistoryById(id),
    staleTime: 1000 * 60, // 1 minute
    enabled: !!id,
  });
};
